(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2234],{

/***/ 40902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/facebook-cancellations-and-refunds/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-03-29",
      tag: "Facebook Marketplace",
      title: "A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Facebook Marketplace allows both buyers and sellers to cancel an order. They can also cancel an order automatically if the seller fails to fulfill it within seven days since the buyer purchased it. If the seller sold the item with onsite checkout and shipping, the order could get canceled by both parties at any time so long as the system confirms that it has not been shipped yet."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are different reasons why a seller would wish to cancel an order. It could be a problem with the inventory (e.g., listed an item that's already sold) or changes in the condition of the listing (e.g., the item got damaged before they dispatched it to the buyer), to name some possibilities."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Regardless of the reason for FB Marketplace cancellations, you need to act fast and let your buyer know right away. Avoid the tendency to reach out only on the day you're supposed to ship it out \u2013 or worse, let the expected shipping date lapse. Do your best to convince the buyer to cancel the order on your behalf. There will be little to no inconvenience since you've managed their expectations early on, and the refund will come in soon."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On the other hand, your seller metrics could take a hit if you are not mindful of the cancellations you make here and there."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How do cancellations affect Shipping Performance?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Facebook Marketplace defines a seller's Cancellation Rate as the percentage of canceled orders made by you or by Facebook, excluding pending orders. It is one of the two metrics determining your Shipping Performance \u2013 the other metric being Missed Handling Rate (orders canceled or not shipped within three days)."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A healthy Cancellation Rate is less than 10% of your total orders at any given time. Facebook will notify you when you're nearing or have reached this mark. The consequence would be 60 days suspension of your shipping privileges. Your listings that require shipping will be taken off the Marketplace during this time."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If this metric repeatedly falls by the wayside, you may be permanently banned from selling with shipping. You should always be on top of your Cancellation Rate, which you can easily track through the \"Insights\" tab on your seller dashboard."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What's the process for FB Marketplace refunds? "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now that you know how important cancellations are, don't readily resort to canceling an order. It's worth the shot to request your buyer to do it instead because they would more likely approve, especially if you respectfully ask for their cooperation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you're successful and your buyer agrees to cancel the order, the only thing left to do is refund them immediately. Under \"Your Listings,\" locate the order in question and tap \"Refund.\" The amount, which will be deducted from your pending payout, is released to the buyer within two business days."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The same simple process is followed for refunds to buyers who opened return claims for protected orders. Under the Facebook Marketplace Purchase Protection, buyers may request a refund within 45 to 60 days of the delivery or expected delivery of the item (in case of unauthorized purchases) on the following conditions:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "There's a \"Purchase Protection\" badge on the listing."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The order was processed using onsite checkout."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Shipping was purchased on the platform as well."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Only any of these reasons are eligible for refunds:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "There was no item received."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Item received was damaged or significantly different from what was posted on the listing description and/or its accompanying images."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The purchased item has no consent from the buyer."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The buyer is not honoring the refund policy published on their listing."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If Facebook has decided in favor of the buyer and you would like to appeal, you may do so within ten days since the case's resolution. Fortify your appeal with as much information and images as you can share to help your case. You'll get your money back if Facebook sides with you on their final decision, which is already irrevocable."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Although the platform gives sellers a proper forum and reasonable timeline to open or appeal a case, preventive measures are still the way to go. Strictly observe these measures if you do not want to spend time and effort filing and defending your case."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "These are some safety tips to practice: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Avoid dealing with cancellations (either by you or by the buyer) and consequent refunds by making sure your inventory is in order. Check the condition of the items before listing. Meet buyers' expectations by being honest in your listing description. The images you post should also match what the buyer will receive."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Never attempt to cancel an order without communicating with the buyer first. Politely and promptly ask them for a favor to do the canceling. Then process their refund immediately."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Develop the habit of shipping your orders at the soonest possible time. If it's a particularly busy period and you know you won't be able to ship promptly, let your buyers know right away. In any case, don't go beyond the timelines set by Facebook."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Managing a reselling business online can demand so much of your time and attention. If you're a Facebook Marketplace seller who also lists on other platforms, consider getting an all-in-one app like OneShop that allows you to cross-list to Poshmark and Mercari seamlessly and more. Sign up for its free 7-day trial today!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/facebook-cancellations-and-refunds.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Aside from managing refunds, there's more at stake for sellers when orders get canceled on FB Marketplace. Fortunately, there are ways to handle these situations well with minimized risks. Read our tips and tricks below."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/facebook-cancellations-and-refunds"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/facebook-cancellations-and-refunds"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Aside from managing refunds, there's more at stake for sellers when orders get canceled on FB Marketplace. Fortunately, there are ways to handle these situations well with minimized risks. Read our tips and tricks below."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Facebook Marketplace"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 36250:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/facebook-cancellations-and-refunds",
      function () {
        return __webpack_require__(40902);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(36250); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);